import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'
import { deleteElementFromPath, setValueForPathWithCreate } from '../../object.util'

export const moveNoPatientFlag = (pcr: any): IPcr => {
  try {
    const patientInfo = pcr?.patient?.patientInformation
    if (patientInfo?.noPatient !== undefined) {
      // If "noPatient" exists, set "hasPatient" as the inverse and delete "noPatient"
      setValueForPathWithCreate(pcr, 'patient.patientInformation.hasPatient', !patientInfo.noPatient)
      deleteElementFromPath(pcr, 'patient.patientInformation.noPatient')
    } else {
      // If "noPatient" is undefined, check for data in the relevant fields
      // Note: "patientDemographics" might have been created in older charts as default data.
      const hasPatient =
        pcr?.patient?.patientDemographics ||
        pcr?.patient?.patientMedicalHistory ||
        pcr?.patient?.patientAllergies ||
        pcr?.patient?.patientMedications ||
        pcr?.billing
          ? true
          : false
      setValueForPathWithCreate(pcr, 'patient.patientInformation.hasPatient', hasPatient)
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule moveNoPatientFlag: ${error}`)
    throw error
  }
}
